var map = {
	"./EVO.png": 1672,
	"./Path 20295.png": 1673,
	"./ab-img.webp": 1674,
	"./ab-title-cn.webp": 1675,
	"./ab-title-en.webp": 1676,
	"./ag-img.png": 1677,
	"./ag-img.webp": 1678,
	"./ag-title-cn.webp": 1679,
	"./ag-title-en.webp": 1680,
	"./chess-img.webp": 1681,
	"./coin-img.webp": 1682,
	"./content-img.webp": 1683,
	"./dg-img.webp": 1684,
	"./dg-title-cn.webp": 1685,
	"./dg-title-en.webp": 1686,
	"./diamond-img.webp": 1687,
	"./dice-coin.webp": 1688,
	"./ea-img.webp": 1689,
	"./ea-title-cn.webp": 1690,
	"./ea-title-en.webp": 1691,
	"./evo-img.webp": 1692,
	"./evo-title-cn.webp": 1693,
	"./evo-title-en.webp": 1694,
	"./golddice-img.webp": 1695,
	"./gp-img.webp": 1696,
	"./gp-title-cn.webp": 1697,
	"./gp-title-en.webp": 1698,
	"./heart-coin-img.webp": 1699,
	"./lc-bg.webp": 1700,
	"./mg-img.webp": 1701,
	"./mg-title-cn.webp": 1702,
	"./mg-title-en.webp": 1703,
	"./pp-img.webp": 1704,
	"./pp-title-cn.webp": 1705,
	"./pp-title-en.webp": 1706,
	"./pt-img.webp": 1707,
	"./pt-title-cn.webp": 1708,
	"./pt-title-en.webp": 1709,
	"./sa-img.webp": 1710,
	"./sa-title-cn.webp": 1711,
	"./sa-title-en.webp": 1712,
	"./sbo-img.webp": 1713,
	"./sbo-title-cn.webp": 1714,
	"./sbo-title-en.webp": 1715,
	"./spade-img.webp": 1716,
	"./title-cn.webp": 1717,
	"./title-en.webp": 1718,
	"./white-spade-img.webp": 1719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1671;